import { constants } from "fs/promises";
import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { GridActionType, GRID_ACTION_TYPES } from "../assets/types";
import { Constants } from "../assets/utils/lib/constants";

type actionHandler = (action: GridActionType, id: string) => void;

export function useActionFromQuery(
    onAction?: actionHandler
) {
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        if (!onAction || !searchParams.get("action")) return;

        const action = searchParams.get("action") as GridActionType | null;
        const id = searchParams.get("id");

        if (
            action &&
            (action === GRID_ACTION_TYPES.EDIT ||
                action === GRID_ACTION_TYPES.VIEW) &&
            id
        ) {
            onAction(action, id);
        }
    }, [searchParams]);

    
    const setSearchAction = useCallback(
        (action: GridActionType | string, entityid?: string | undefined) => {
            const id: string = entityid ?? Constants.emptyGuid;
            switch (action)
            {
                case GRID_ACTION_TYPES.EDIT:
                case GRID_ACTION_TYPES.VIEW
                    : return setSearchParams(
                        { action, id },
                        { replace: true }
                    ); 
                case GRID_ACTION_TYPES.NEW
                    : clearSearchAction();
                    break;
                default: clearSearchAction();
            }
        },
        [setSearchParams]
    );

    const clearSearchAction = useCallback(() => {
        setSearchParams({}, { replace: true });
    }, [setSearchParams]);

    return {
        setSearchAction,
        clearSearchAction
    };
}
